import { liveRadios } from './liveRadios';
import { programs } from './programs';

export interface LiveProgram {
  id: number;
  name: string;
  slug: string;
  host: string;
  hostPhotoUrl: string;
  radioName: string;
  radioFrequency: string;
  radioSlug: string;
  category: string;
  followers: number;
  interactions: number;
  activityScore: number;
  coverUrl: string;
  status: string;
  upTime: string;
}

function buildLivePrograms(): LiveProgram[] {
  const result: LiveProgram[] = [];
  const seen = new Set<string>();

  for (const radio of liveRadios) {
    const prog = radio.programs[0];
    if (!prog || seen.has(prog.name)) continue;
    seen.add(prog.name);

    const programMeta = programs.find(p => p.name === prog.name);
    const broadcaster = radio.broadcasters.find(b => b.name === prog.host);

    const freqSlug = radio.frequency.replace(/[.\s]+FM$/g, '').replace(/\./g, '-');

    result.push({
      id: prog.id || radio.id,
      name: prog.name,
      slug: programMeta?.slug || prog.name.toLowerCase().replace(/\s+/g, '-'),
      host: prog.host,
      hostPhotoUrl: broadcaster?.photoUrl || radio.broadcasters[0]?.photoUrl || '',
      radioName: radio.name,
      radioFrequency: radio.frequency,
      radioSlug: freqSlug,
      category: radio.category,
      followers: programMeta?.followers || 0,
      interactions: radio.interactionScore,
      activityScore: radio.activityScore,
      coverUrl: programMeta?.coverUrl || radio.thumbnailUrl,
      status: radio.status,
      upTime: radio.upTime,
    });
  }

  return result;
}

export const livePrograms: LiveProgram[] = buildLivePrograms();

export const liveProgramsStats = {
  totalPrograms: livePrograms.length,
  totalFollowers: livePrograms.reduce((s, p) => s + p.followers, 0),
  totalListeners: liveRadios.reduce((s, r) => s + r.currentListeners, 0),
  totalRadios: liveRadios.length,
  avgInteractions: Math.round(livePrograms.reduce((s, p) => s + p.interactions, 0) / livePrograms.length),
};

export type ProgramSortMode = 'activity' | 'interactions' | 'followers';